import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * PageLayout — shared shell that wraps every page with Navbar + Footer.
 * Pages no longer need to import Navbar or Footer individually.
 */
export default function PageLayout({ children }) {
  return (
    <div className="pi">
      <Navbar />
      <main className="page-main">
        {children}
      </main>
      <Footer />
    </div>
  );
}
